import { TOOLTIP_SHOW, TOOLTIP_HIDE } from '../constants';

const showToolTip = value => ({
  type: TOOLTIP_SHOW,
  payload: { value },
});

const hideToolTip = value => ({
  type: TOOLTIP_HIDE,
  payload: { value },
});

export { showToolTip, hideToolTip };
